import React from 'react';
import './toolbarButton.css';

const toolbarButton = ({ className, dataTest, children }) => {
    const classes = `${className || ''} mdttoolbar-button`;

    return (
        <div className={classes} data-test={dataTest}>
            {children}
        </div>
    );
};

export default toolbarButton;
